import { LDProvider } from "launchdarkly-react-client-sdk";
import { FC, useMemo } from "react";
import { useAuthState } from "../modules/auth";

const LaunchDarklyProvider: FC = ({ children }) => {
  const { userId, email, companyId, companyName } = useAuthState();

  const context = useMemo(
    () =>
      userId
        ? {
            kind: "user" as const,
            key: userId,
            email,
            companyId,
            companyName,
          }
        : { kind: "user" as const, key: "anonymous", anonymous: true },
    [userId, email, companyId, companyName],
  );

  return (
    <LDProvider
      clientSideID={process.env.NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_ID as string}
      context={context}
      options={{ bootstrap: "localStorage" }}
    >
      {children}
    </LDProvider>
  );
};

export { LaunchDarklyProvider };
